export const EMAIL_CACHE_KEY = 'di:get-my-rates:email';

export function writeEmailToCache(email: string) {
  try {
    localStorage.setItem(EMAIL_CACHE_KEY, email);
  } catch (e) {
    console.warn('Could not write email to cache', e);
  }
}

export function readEmailFromCache(): string | null {
  try {
    const raw = localStorage.getItem(EMAIL_CACHE_KEY);

    if (!raw) {
      return null;
    }

    return typeof raw === 'string' ? raw : null;
  } catch {
    return null;
  }
}
